const breadCrumb = "Lotação de Servidores - Diretores e Secretários";

const routes = [
  {
    path: "/substituir-responder-diretor-e-secretario",
    name: "substituir-responder-diretor-e-secretario",
    meta: {
      allowedPermissions: ["nomeacao_substituto_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/DiretoresESecretarios/SubstituirResponderDiretorESecretario/SubstituirResponderDiretorESecretarioHome.vue"
      ),
  },
  {
    path: "/substituir-responder-diretor-e-secretario/novo",
    name: "substituir-responder-diretor-e-secretario-novo",
    meta: {
      allowedPermissions: ["nomeacao_substituto_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/DiretoresESecretarios/SubstituirResponderDiretorESecretario/SubstituirResponderDiretorESecretarioCad.vue"
      ),
  },
  {
    path: "/substituir-responder-diretor-e-secretario/consultar/:id",
    name: "substituir-responder-diretor-e-secretario-consultar",
    meta: {
      allowedPermissions: ["nomeacao_substituto_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/DiretoresESecretarios/SubstituirResponderDiretorESecretario/SubstituirResponderDiretorESecretarioConsultar.vue"
      ),
  },
  {
    path: "/substituir-responder-diretor-e-secretario/editar/:id",
    name: "substituir-responder-diretor-e-secretario-editar",
    meta: {
      allowedPermissions: ["nomeacao_substituto_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/DiretoresESecretarios/SubstituirResponderDiretorESecretario/SubstituirResponderDiretorESecretarioEdit.vue"
      ),
  },
];

export default routes;
